"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("core-js/modules/es6.regexp.match");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _router = _interopRequireDefault(require("./router"));
var _store = _interopRequireDefault(require("./store"));
var _nprogress = _interopRequireDefault(require("nprogress"));
require("nprogress/nprogress.css");
var _pageTitle = require("@/utils/page-title");
// progress bar
// progress bar style

_nprogress.default.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login', '/register']; // no redirect whitelist

var hasAddRoute = false;
_router.default.beforeEach( /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(to, from, next) {
    var regex, url, hasToken, hasTicket, hasRole, hasTicketLogin, accessRoutes, _accessRoutes;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!to.fullPath.includes('logOut=true')) {
            _context.next = 6;
            break;
          }
          _context.next = 3;
          return _store.default.dispatch('user/logout');
        case 3:
          regex = /url=(.*?)(&|$)/;
          url = window.location.href.match(regex)[1];
          next({
            path: "/login?url=".concat(url)
          });
          // next({ path: `/login` })
          // window.location.href = '/web/sso/'
        case 6:
          if (to.path.includes('login')) hasAddRoute = false;
          // start progress bar
          _nprogress.default.start();

          // set page title
          document.title = (0, _pageTitle.getPageTitle)(to.meta.title);

          // determine whether the user has logged in
          hasToken = _store.default.getters.token;
          hasTicket = _store.default.getters.ticket;
          if (!(hasToken || hasTicket)) {
            _context.next = 46;
            break;
          }
          if (!(to.path === '/login')) {
            _context.next = 17;
            break;
          }
          // if is logged in, redirect to the home page
          next({
            path: '/'
          });
          _nprogress.default.done();
          _context.next = 44;
          break;
        case 17:
          hasRole = _store.default.getters.role && _store.default.getters.role > 0;
          if (!(hasRole || hasTicket)) {
            _context.next = 30;
            break;
          }
          if (!(_store.default.getters.menu === '')) {
            _context.next = 23;
            break;
          }
          hasTicketLogin = true;
          _context.next = 23;
          return _store.default.dispatch('user/ticketLogin');
        case 23:
          _context.next = 25;
          return _store.default.dispatch('permission/generateRoutes');
        case 25:
          accessRoutes = _context.sent;
          if (accessRoutes.length > 0 && !hasAddRoute) {
            hasAddRoute = true;
            _router.default.addRoutes(accessRoutes);
          }
          if (hasTicketLogin) {
            next(to.path);
            hasTicketLogin = true;
          } else {
            next();
          }
          _context.next = 44;
          break;
        case 30:
          _context.prev = 30;
          _context.next = 33;
          return _store.default.dispatch('permission/generateRoutes');
        case 33:
          _accessRoutes = _context.sent;
          if (_accessRoutes.length > 0 && !hasAddRoute) {
            hasAddRoute = true;
            _router.default.addRoutes(_accessRoutes);
          }
          next((0, _objectSpread2.default)((0, _objectSpread2.default)({}, to), {}, {
            replace: true
          }));
          _context.next = 44;
          break;
        case 38:
          _context.prev = 38;
          _context.t0 = _context["catch"](30);
          _context.next = 42;
          return _store.default.dispatch('user/resetToken');
        case 42:
          next("/login?redirect=".concat(to.path));
          _nprogress.default.done();
        case 44:
          _context.next = 47;
          break;
        case 46:
          /* has no token*/
          if (whiteList.indexOf(to.path) !== -1) {
            console.log('白名单，直接跳转');
            // in the free login whitelist, go directly
            next();
          } else {
            console.log('没有token，非白名单，跳转登录页');
            // other pages that do not have permission to access are redirected to the login page.
            next("/login?redirect=".concat(to.fullPath));
          }
        case 47:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[30, 38]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
_router.default.afterEach(function () {
  // finish progress bar
  _nprogress.default.done();
});